import { useEffect, useRef, useState } from 'react';
import Markdown from 'react-markdown';
import { Body1 } from './Typography';

type Props = {
  text?: string;
  /** Milliseconds per character. */
  speed?: number;
  fontSize?: string;
  /** Called once the whole text is shown. */
  onDone?: () => void;
  [key: string]: unknown;
};

const TypewriterAnimation = ({ text = '', speed = 50, fontSize = '1rem', onDone, ...props }: Props) => {
  const [displayed, setDisplayed] = useState('');
  // A ref, so a new callback on each parent render does not restart the typing.
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    setDisplayed('');
    if (!text) {
      onDoneRef.current?.();
      return;
    }
    let i = 0;
    const interval = setInterval(() => {
      const char = text[i];
      if (typeof char === 'string') {
        setDisplayed(prev => prev + char);
      }
      i++;
      if (i >= text.length) {
        clearInterval(interval);
        onDoneRef.current?.();
      }
    }, speed);
    return () => clearInterval(interval);
  }, [text, speed]);

  return (
    <Body1 {...props} sx={{ fontSize, ...(props.sx as object) }}>
      <Markdown components={{ p: 'div' }}>{displayed}</Markdown>
    </Body1>
  );
};

export default TypewriterAnimation;
